/* eslint-disable no-unused-expressions */
const genreObjIntoStrConvert= (genreObj) => {

    const entries = Object.entries(genreObj);
    let genreStr='';
    for(let i = 0; i < entries.length; i++) {
      entries[i][1] ?
      genreStr = genreStr + ','+entries[i][0].toString()
      : null;
    }
    
    // console.log('genre string: ', genreStr.substring(1));

    return genreStr.substring(1)
  }

export default genreObjIntoStrConvert;